<template>
  <vs-col
    vs-type="flex"
    vs-justify="center"
    vs-align="center"
    :vs-w="width"
    vs-sm="4"
    vs-xs="12"
  >
    <vs-card>
      <slot></slot>
    </vs-card>
  </vs-col>
</template>

<script>
export default {
  props: {
    width: {
      type: Number,
      default: 4,
    },
  },
};
</script>
